export enum BankAccountTypes {
    Checking = "Checking",
    Savings = "Savings"
}
